export default __webpack_public_path__ + "static/media/flow_img.c3fb3c96.png";